import React from "react";
import "./Profile.scss";

const ProfileLayout = ({ children }) => {
  return (
    <div className="profile-layout-wrapper">
      <div className="profile-content-area">
        {children}
      </div>
    </div>
  );
};

export default ProfileLayout;